import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSquareLinkedin, faSquareGithub, faSquareWhatsapp } from '@fortawesome/free-brands-svg-icons'
import { faSquarePhone, faAt, faEnvelope, faLocationDot, faCakeCandles, faArrowUpRightFromSquare, faHatCowboy } from '@fortawesome/free-solid-svg-icons'

export default function Image({ src, alt, color }) {
    const images = {
        github: {
            from: FontAwesomeIcon,
            icon: faSquareGithub
        },
        telefon: {
            from: FontAwesomeIcon,
            icon: faSquarePhone,
            color: "green"
        },
        linkedin: {
            from: FontAwesomeIcon,
            icon: faSquareLinkedin
        },
        at: {
            from: FontAwesomeIcon,
            icon: faAt,
            color: "black"
        },
        email: {
            from: FontAwesomeIcon,
            icon: faEnvelope,
            color: "black"
        },
        location: {
            from: FontAwesomeIcon,
            icon: faLocationDot,
            color: "black"
        },
        birthday: {
            from: FontAwesomeIcon,
            icon: faCakeCandles,
            color: "black"
        },
        whatsapp: {
            from: FontAwesomeIcon,
            icon: faSquareWhatsapp,
            color: "#25d366"
        },
        website: {
            from: FontAwesomeIcon,
            icon: faArrowUpRightFromSquare,
            color: "blue"
        },
        experience_time: {
            from: FontAwesomeIcon,
            icon: faHatCowboy
        }
    }

    const image = images[src]

    if (image.from == FontAwesomeIcon) {
        return (
            <FontAwesomeIcon
                icon={image.icon} 
                color={color || image.color || "rgb(30, 48, 80)"}
            />
        )
    }

    return (
        <img src={image} alt={alt} />
    )
}